/**
 * Delivery Date Conditional
 *
 * The Pickeasy "Order Delivery Date & Time" app injects a "Pick Your Delivery
 * Date" widget (`#order-slots`) plus hidden cart-attribute inputs
 * (`#order-slots-cart-attributes`) into the cart drawer. It blocks the "Check
 * out" button until a date is chosen, even when the cart only contains dry
 * goods.
 *
 * Only fish and coral (livestock) actually need a delivery date. When the cart
 * contains NO livestock, this script removes the app's widget and hidden
 * inputs so supplement-only (UPS Ground) orders can check out without picking
 * a date. When livestock IS present, the widget is left untouched and the app
 * keeps enforcing the date selection.
 *
 * Each cart line item is server-rendered with a `data-requires-delivery-date`
 * attribute (see `snippets/delivery-date-required.liquid`), so no extra
 * network requests are needed and the classification follows the full product
 * catalog data.
 */
(() => {
  const REQUIRES_DATE_ATTR = 'data-requires-delivery-date';

  function cartContainsLivestock() {
    const rows = document.querySelectorAll(`[${REQUIRES_DATE_ATTR}]`);
    return Array.from(rows).some(
      (row) => row.getAttribute(REQUIRES_DATE_ATTR).trim() === 'true'
    );
  }

  function removePickeasyWidgets() {
    // Drop the visible delivery-date widget...
    document.querySelectorAll('#order-slots').forEach((el) => el.remove());
    // ...the hidden cart-attribute inputs (date/time/fulfillment type)...
    document.querySelectorAll('#order-slots-cart-attributes').forEach((el) => el.remove());
    // ...and any "Select an order slot to proceed" validation error that a
    // previous blocked submit may have left behind.
    document.querySelectorAll('#order-slots-error').forEach((el) => el.remove());
  }

  function evaluate() {
    // Fish/coral in the cart -> the app's widget stays and stays required.
    if (cartContainsLivestock()) return;

    // Supplement-only cart -> skip the delivery-date requirement entirely.
    removePickeasyWidgets();
  }

  evaluate();

  /**
   * The app can (re)inject its widget at any time: on page load, when the cart
   * drawer opens, and after cart changes trigger a section re-render. Watch the
   * cart surfaces and re-apply the removal whenever the widget appears.
   */
  const CART_SCOPE_SELECTOR = '#CartDrawer, #main-cart-items';

  function mutationTargetsCart(mutation) {
    if (mutation.target && mutation.target.nodeType === 1) {
      if (mutation.target.matches && mutation.target.matches(CART_SCOPE_SELECTOR)) {
        return true;
      }
      if (mutation.target.closest && mutation.target.closest(CART_SCOPE_SELECTOR)) {
        return true;
      }
    }
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (
        node.id === 'order-slots' ||
        node.id === 'order-slots-cart-attributes' ||
        (node.matches && node.matches(`[${REQUIRES_DATE_ATTR}]`))
      ) {
        return true;
      }
    }
    return false;
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutationTargetsCart(mutation)) {
        evaluate();
        return;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
